import Typography from '@mui/material/Typography';
import { useTranslate } from 'react-admin';
import Box from '@mui/material/Box';

interface Props {
    label: string;
    source: string;
    children: React.ReactNode;
    alwaysOn?: boolean;
}

const FilterBox = ({ label, children }: Props) => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
                border: '1px rgb(9,23,71,0.1) solid',
                p: 1,
                borderRadius: 1,
            }}
        >
            <Typography>
                <b>{translate(label)}</b>
            </Typography>

            {children}
        </Box>
    );
};

export default FilterBox;
